require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-budgeting-breakdown-how-to-create-and-maintain-a-budget-that-works.json") })
        }
      }, "path---articles-budgeting-breakdown-how-to-create-and-maintain-a-budget-that-works");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-budgeting-breakdown-how-to-create-and-maintain-a-budget-that-works!./.cache/json/articles-budgeting-breakdown-how-to-create-and-maintain-a-budget-that-works.json
// module id = 1563
// module chunks = 231608221292675